/* eslint-disable no-useless-computed-key */
import errors from './errors';
import logger from '@/logger';
import { store } from './redux/store';

const fetch = window.fetch;

function getHeaders(headers = {}, options) {
	const { auth0Token } = store.getState().auth;
	const { useAuthHeader } = options;
	return {
		[useAuthHeader || 'Authorization']: `Bearer ${auth0Token}`,
		['Content-Type']: 'application/json',
		...headers,
	};
}

export function caughtError(e) {
	logger.error(e, { location: 'fetch.caughtError', message: 'Network error' });
	if (e && e.result && e.result.length > 0) errors.showErrors(e.result);
}

export default function(url, fetchConfig = {}, options = {}) {
	return fetch(url, {
		...fetchConfig,
		headers: getHeaders(fetchConfig.headers, options),
	}).catch(err => logger.error(err, { location: 'fetch.default', message: 'Network error' }));
}
